<div *vsLet="isPastWaitingPeriod$ | async as isPastWaitingPeriod">
  <vs-content-card
    *vsLet="warranty$ | async as warranty"
    [header]="{ title: 'Claims', subtitle: 'Filed claims, their status, and next steps' }"
  >
    <div
      *ngIf="canOpenClaim$ | async"
      headerEnd
      matTooltipPosition="right"
      [vsTooltip]="
        remainingPeriod > 0 && isPastWaitingPeriod === false
          ? 'Remaining ' + remainingPeriod + ' ' + period + ' of the waiting period.'
          : ''
      "
      tooltipStyle="light"
    >
      <button
        vs-button
        theme="primary"
        slot="header-end"
        routerLink="claim/open"
        [disabled]="isPastWaitingPeriod === false"
      >
        <vs-icon name="file-plus-02"></vs-icon> Open a new claim
      </button>
    </div>

    <ng-container *vsLet="placeholderWhenClaims$ | async as placeholderWhenClaims">
      <ng-container *ngIf="table.paginationConfig$ | async as pagination">
        <ng-container *ngIf="pagination.totalItems > 0">
          <div
            *ngIf="placeholderWhenClaims"
            class="py-8 px-4 sm:px-6 border-b [&+ws-claims-table>div]:!mt-1"
            [innerHTML]="placeholderWhenClaims | safe: 'html'"
          ></div>
        </ng-container>
      </ng-container>

      <ws-claims-table
        #table
        [period]="period"
        [hideBorder]="true"
        [hideFilters]="true"
        [hideCustomer]="true"
        [isCustomerPortal]="true"
        [warranty]="warranty ?? null"
        [customerId]="warranty?.customerId"
        [isPastWaitingPeriod]="isPastWaitingPeriod"
        [remainingPeriod]="remainingPeriod"
        [hidePagination]="((table.paginationConfig$ | async)?.totalItems ?? 0) < 11"
      >
        <div
          *ngIf="placeholderWhenNoClaims$ | async as placeholderWhenNoClaims"
          slot="placeholder"
          class="py-8 px-4 sm:px-6"
          [innerHTML]="placeholderWhenNoClaims | safe: 'html'"
        ></div>
      </ws-claims-table>
    </ng-container>
  </vs-content-card>
</div>
